import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { RolesApiClient, UpdateRoleAccessRequest } from "../../web-api-client";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { appConfig } from "../../appconfig";

export function useUpdateRoleAccess() {
  const qc = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (input: { roleId: string; permissions: string[] }) => {
      const client = new RolesApiClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", { replace: true, state: { from: window.location.pathname } }),
        }),
      });

      const req = new UpdateRoleAccessRequest({
        permissions: input.permissions,
      } as any);

      return await client.updateRoleAccess(input.roleId, req);
    },
    onSuccess: async (_, v) => {
      await qc.invalidateQueries({ queryKey: ["role-access", v.roleId] });
      await qc.invalidateQueries({ queryKey: ["roles"] });
    },
  });
}
